import React from 'react';
import { useTranslation } from 'react-i18next';
import WidgetButton from './WidgetButton';
import WidgetFeedbackModal from '../WidgetFeedbackModal';
import { ChevronRight } from '../../../../SVG';
export var GiveFeedbackButton = function (_a) {
    var setIsFeedbackOpen = _a.setIsFeedbackOpen, isFeedbackOpen = _a.isFeedbackOpen, userHasInteracted = _a.userHasInteracted;
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(WidgetButton, { handleClick: function () {
                userHasInteracted.current = true;
                setIsFeedbackOpen(true);
            }, className: "w-full" },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "flex justify-between" },
                    React.createElement("p", { className: "mb-2 text-left font-normal leading-normal" }, t('widget.openFeedbackButton.header', 'Help Us Improve')),
                    React.createElement(ChevronRight, { height: "15", width: "15" })),
                React.createElement("p", { className: "text-left font-light leading-normal tracking-semi-wide text-gray-500" }, t('widget.openFeedbackButton.description', 'Let us know how we can make your chat experience better.')))),
        isFeedbackOpen && (React.createElement(WidgetFeedbackModal, { isOpen: isFeedbackOpen, setIsFeedbackOpen: setIsFeedbackOpen, conversationId: 0 }))));
};
export default GiveFeedbackButton;
